angular.module('dentalLinks')
    .controller('ToProviderController', ['$scope', 'Logger', 'Auth', '$uibModal', 'ModalHandler', 'Practice', 'Notification',
        function ($scope, Logger, Auth, $uibModal, ModalHandler, Practice, Notification) {
            /**
             * Opens a modal dialog to invite a provider to join DentalCareLinks.
             * Dialog will do one of:
             * 1. return existing practice/provider pair
             * 2. return ProviderIvitation object as provider if:
             *    - new invitation was sent or
             *    - existing invitation was selected
             */
            $scope.providerDialog = function () {
                var modalInstance = $uibModal.open({
                    templateUrl: 'partials/provider_form.html',
                    controller: 'ProviderModalController',
                    resolve: {
                        dependsOnReferral: function(){
                            return true;
                        },
                        inviterId: function(){
                            return Auth.getOrRedirect().id;
                        }
                    }
                });
                ModalHandler.set(modalInstance);
                modalInstance.result.then(function (result) {
                    var selectedPractice = result.practice;
                    var invitedProvider = result.provider;
                    
                    if (selectedPractice) {
                        // if existing user's email was entered, then confirmed selection of existing practice as destination.
                        $scope.destinationPractice = {users: [], name: selectedPractice.name};
                        $scope.practiceSearchText = selectedPractice.name;

                        Practice.getByPublicId({publicId: selectedPractice.public_id}, function(practice) {
                            $scope.onPracticeSelected(practice);
                            $scope.form.$setDirty();
                        }, function (failure) {
                            Notification.error(failure.data.message);
                        });

                    } else {
                        // otherwise a new practice was just successfully invited
                        // Todo: confirm that we don't need to do anything different here in case existing ProviderInvitation was selected instead of creating a new one.
                        $scope.destinationPractice = {users: [invitedProvider], name: '-- pending registration (' + invitedProvider.email + ') --'};
                        $scope.practiceSearchText = $scope.destinationPractice.name;
                        $scope.model.referral.dest_provider_invited_id = invitedProvider.id;
                    }

                    $scope.model.referral.isCreatedNow = true;
                    $scope.form.$setDirty();  //need for unsaved changes
                    $scope.form.practice.$setValidity('editable', true);//fix for the case, when practice has invalid value and then provider is invited (removes practice's validation error and sets state to valid to enable saving)

                }).catch(function () {
                    // Logger.log('Modal dismissed');
                });
            }
        }]);
